import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { DisplayMessage, GetFormattedDate, ValidateDate } from '../../../../services/helpers.js';
import { PlanningTeamMembersUrl } from '../../../../constants/apiUrls.js';
import { Box } from '@material-ui/core';
import appFetch from '../../../../api/appFetch.js';
import OutletUsersDropdown from '../../../Common/Dropdowns/OutletUsersDropdown.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';

export default class TeamMemberNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            teamId: this.props.teamId,
            outletUserId: 0,
            memberName: undefined,
            memberFrom: "",
            memberTill: "",
            createdOn: undefined,
            createdByName: undefined,
            outletUsers: [],
            loading: true,
            redirect: false,
            requestInProgress: false
        };
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleMemberFromChange = value => this.setState({ memberFrom: value });

    handleMemberTillChange = value => this.setState({ memberTill: value });

    saveTeamMember = () => {
        if (this.state.memberFrom === "" || this.state.memberFrom === undefined || !ValidateDate(this.state.memberFrom)) {
            DisplayMessage(this.props.resources["InvalidStartDate"], "error");
            return;
        }

        if (this.state.memberFrom != "" && !ValidateDate(this.state.memberTill)) {
            DisplayMessage(this.props.resources["InvalidEndDate"], "error");
            return;
        }
        let memberFrom = GetFormattedDate(this.state.memberFrom);
        let memberTill = GetFormattedDate(this.state.memberTill == "" ? undefined : this.state.memberTill);

        if (memberTill !== null && (memberFrom > memberTill || memberTill.indexOf("NaN") > -1)) {
            DisplayMessage(this.props.resources["InvalidEndDate"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            teamId: this.state.teamId,
            outletUserId: this.state.outletUserId,
            memberFrom: memberFrom,
            memberTill: memberTill,
        });
        const url = PlanningTeamMembersUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    DisplayMessage("New Team Member was saved!", "success");
                }
                this.handleCancel();
            },
            onError: (data, response) => {
                if (response.statusText.length > 0) {
                    DisplayMessage(response.statusText, "error");
                }
                else {
                    for (var i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleCancel = () => {
        this.props.closeDialogMembers();
    }

    renderForm() {
        let resources = this.props.resources;
        var helperTextMemberFrom = this.state.memberFrom === "" ? "helper-text-red" : "helper-text-grey";
        return (
            <Form  >
                <Form.Group style={{ display: "flex" }}>
                    <div className="col-2"></div>
                    <OutletUsersDropdown
                        resources={resources}
                        outletUser={this.state.outletUserId}
                        onOutletUserChange={this.handleChange}
                        onRequestStart={() => this.setState({ requestInProgress: true })}
                        onRequestEnd={() => this.setState({ requestInProgress: false, loading: false })}
                        filter={() => true}
                        containerClass="col-8"
                        inputName="outletUserId"
                        required
                    />
                </Form.Group>

                <Form.Group style={{ display: "flex" }}>
                    <Form.Label className="col-2 label-mt my-auto" > </Form.Label>
                    <Box display="flex" justifyContent="space-between" className='col-8' padding="0" style={{gap: "10px"}}>
                        <DatePickerComponent
                            id="dateMemberFrom"
                            label={resources["MemberFrom"]}
                            value={this.state.memberFrom}
                            onChange={this.handleMemberFromChange}
                            error={!this.state.memberFrom}
                            helperText={resources["PleasePickADate"]}
                            minDate={new Date("2000-01-01")}
                            required
                        />
                        <DatePickerComponent
                            id="memberFrom"
                            label={resources["MemberTill"]}
                            value={this.state.memberTill}
                            onChange={this.handleMemberTillChange}
                            helperText={resources["PleasePickADate"]}
                            minDate={new Date("2000-01-01")}
                        />
                    </Box>
                </Form.Group>
                <Form.Group style={{ display: "flex" }} >
                    <div className="col-2">
                    </div>
                    <div className="col-8 pr-0">
                        <div className="float-right mr-0">
                            <Button className="btn btn-primary pull-right margin my-2 mx-2" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }} title={resources["Cancel"]} type="button" onClick={this.handleCancel} >
                                {resources["Cancel"]}
                            </Button>
                            <Button className="btn btn-primary pull-right margin my-2 ml-2" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }} title={resources["Save"]} type="button" onClick={this.saveTeamMember} disabled={this.state.requestInProgress}>
                                {resources["Save"]}
                            </Button>
                        </div>
                    </div>
                </Form.Group>
            </Form>);
    }

    render() {
        let resources = this.props.resources;
        return (
            <div className={"py-4 " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
                <div className="mb-4  text-center">
                    <h5>{resources["AddNewTeamMemberTitle"]}</h5>
                </div>
                <div className="pt-2">
                    {this.renderForm()}
                </div>

            </div>
        );
    }
}